import { userActionTypes } from './user/userTypes'

export default {
  ...userActionTypes,
}
